import { render, staticRenderFns } from "./SupplyModal.vue?vue&type=template&id=65679ea6&"
import script from "./SupplyModal.vue?vue&type=script&lang=ts&"
export * from "./SupplyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports